import PayerState from './state';
import { PayerTypes } from './types';

const INITIAL_STATE = new PayerState();

export default function payerReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    //-------------------------------------------------
    // GET_PAYER_LIST
    case PayerTypes.GET_PAYER_LIST.LOADING:
      return {
        ...state,
        payerList: {
          ...state.payerList,
          loading: true,
          error: null,
        },
      };
    case PayerTypes.GET_PAYER_LIST.SUCCESS:
      return {
        ...state,
        payerList: {
          loading: false,
          data: action.payload.list,
          total: action.payload.total,
          error: null,
        },
      };
    case PayerTypes.GET_PAYER_LIST.ERROR:
      return {
        ...state,
        payerList: {
          ...state.payerList,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_PAYER_COMPANY
    case PayerTypes.CREATE_PAYER_COMPANY.LOADING:
      return {
        ...state,
        payerCompany: {
          ...INITIAL_STATE.payerCompany,
          loading: true,
        },
      };
    case PayerTypes.CREATE_PAYER_COMPANY.SUCCESS:
      return {
        ...state,
        payerCompany: {
          ...INITIAL_STATE.payerCompany,
          data: action.payload,
        },
      };
    case PayerTypes.CREATE_PAYER_COMPANY.ERROR:
      return {
        ...state,
        payerCompany: {
          ...INITIAL_STATE.payerCompany,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_PAYER_COMPANY
    case PayerTypes.UPDATE_PAYER_COMPANY.LOADING:
      return {
        ...state,
        payerCompany: {
          ...state.payerCompany,
          loading: true,
          error: null,
        },
      };
    case PayerTypes.UPDATE_PAYER_COMPANY.SUCCESS:
      return {
        ...state,
        payerCompany: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case PayerTypes.UPDATE_PAYER_COMPANY.ERROR:
      return {
        ...state,
        payerCompany: {
          ...state.payerCompany,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_PAYER_COMPANY
    case PayerTypes.DELETE_PAYER_COMPANY.LOADING:
      return {
        ...state,
        deletePayerCompany: {
          ...INITIAL_STATE.deletePayerCompany,
          loading: true,
        },
      };
    case PayerTypes.DELETE_PAYER_COMPANY.SUCCESS:
      return {
        ...state,
        deletePayerCompany: {
          ...INITIAL_STATE.deletePayerCompany,
          data: action.payload,
        },
      };
    case PayerTypes.DELETE_PAYER_COMPANY.ERROR:
      return {
        ...state,
        deletePayerCompany: {
          ...INITIAL_STATE.deletePayerCompany,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_PAYER_CONTACT_PERSON
    case PayerTypes.CREATE_PAYER_CONTACT_PERSON.LOADING:
      return {
        ...state,
        payerContactPerson: {
          ...INITIAL_STATE.payerContactPerson,
          loading: true,
        },
      };
    case PayerTypes.CREATE_PAYER_CONTACT_PERSON.SUCCESS:
      return {
        ...state,
        payerContactPerson: {
          ...INITIAL_STATE.payerContactPerson,
          data: action.payload,
        },
      };
    case PayerTypes.CREATE_PAYER_CONTACT_PERSON.ERROR:
      return {
        ...state,
        payerContactPerson: {
          ...INITIAL_STATE.payerContactPerson,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_PAYER_CONTACT_PERSON
    case PayerTypes.UPDATE_PAYER_CONTACT_PERSON.LOADING:
      return {
        ...state,
        payerContactPerson: {
          ...state.payerContactPerson,
          loading: true,
          error: null,
        },
      };
    case PayerTypes.UPDATE_PAYER_CONTACT_PERSON.SUCCESS:
      return {
        ...state,
        payerContactPerson: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case PayerTypes.UPDATE_PAYER_CONTACT_PERSON.ERROR:
      return {
        ...state,
        payerContactPerson: {
          ...state.payerContactPerson,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_PAYER_CONTACT_PERSON
    case PayerTypes.DELETE_PAYER_CONTACT_PERSON.LOADING:
      return {
        ...state,
        deletePayerContactPerson: {
          ...INITIAL_STATE.deletePayerContactPerson,
          loading: true,
        },
      };
    case PayerTypes.DELETE_PAYER_CONTACT_PERSON.SUCCESS:
      return {
        ...state,
        deletePayerContactPerson: {
          ...INITIAL_STATE.deletePayerContactPerson,
          data: action.payload,
        },
      };
    case PayerTypes.DELETE_PAYER_CONTACT_PERSON.ERROR:
      return {
        ...state,
        deletePayerContactPerson: {
          ...INITIAL_STATE.deletePayerContactPerson,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // SET_DEFAULT_PAYER
    case PayerTypes.SET_DEFAULT_PAYER.LOADING:
      return {
        ...state,
        defaultPayer: {
          ...state.defaultPayer,
          loading: true,
          error: null,
        },
      };
    case PayerTypes.SET_DEFAULT_PAYER.SUCCESS:
      return {
        ...state,
        defaultPayer: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case PayerTypes.SET_DEFAULT_PAYER.ERROR:
      return {
        ...state,
        defaultPayer: {
          ...state.defaultPayer,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_PAYER_COMPANIES
    case PayerTypes.GET_PAYER_COMPANIES.LOADING:
      return {
        ...state,
        payerCompanies: {
          ...state.payerCompanies,
          loading: true,
          error: null,
        },
      };
    case PayerTypes.GET_PAYER_COMPANIES.SUCCESS:
      return {
        ...state,
        payerCompanies: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case PayerTypes.GET_PAYER_COMPANIES.ERROR:
      return {
        ...state,
        payerCompanies: {
          ...state.payerCompanies,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
}
